<template>
  <v-row class="mt_dec--40">
    <!-- Start Single Address  -->
    <v-col lg="4" md="4" sm="6" cols="12" class="mt--40">
      <div class="rn-address">
        <div class="icon">
          <i class="fas fa-phone"></i>
        </div>
        <div class="inner">
          <h4 class="title">Contacta por teléfono</h4>
          <p>
            <a :href="phone.link">{{ phone.text }}</a>
          </p>
        </div>
      </div>
    </v-col>
    <!-- End Single Address  -->

    <!-- Start Single Address  -->
    <v-col lg="4" md="4" sm="6" cols="12" class="mt--40">
      <div class="rn-address">
        <div class="icon">
          <i class="fas fa-envelope"></i>
        </div>
        <div class="inner">
          <h4 class="title">Dirección de email</h4>
          <p>
            <a :href="email.link">{{ email.text }}</a>
          </p>
        </div>
      </div>
    </v-col>
    <!-- End Single Address  -->

    <!-- Start Single Address  -->
    <v-col lg="4" md="4" sm="6" cols="12" class="mt--40">
      <div class="rn-address">
        <div class="icon">
          <i class="fas fa-map-marker-alt"></i>
        </div>
        <div class="inner">
          <h4 class="title">Localización</h4>
          <p>
            {{location.text}}
          </p>
        </div>
      </div>
    </v-col>
    <!-- End Single Address  -->
  </v-row>
</template>



<script>
import {ValidationObserver} from "vee-validate";
import {ValidationProvider} from "vee-validate/dist/vee-validate.full.esm";
import {container} from "@/main";
import {ContactService} from "@/pages/contact/contact.service";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  async created() {
    this.contactService = container.get(ContactService);
    const contactData = await this.contactService.getContactData();
    var parser = new DOMParser();
    // Usar parseFromString para convertir la cadena HTML en un documento HTML
    const doc = parser.parseFromString(contactData.content.rendered, 'text/html');
    const email = doc.querySelector('a[href^="mailto:"]');
    const phone = doc.querySelector('a[href^="tel:"]');
    const location = doc.querySelector('div.wp-block-columns.alignwide.is-layout-flex.wp-container-core-columns-is-layout-3.wp-block-columns-is-layout-flex > div:nth-child(2) > p');
    const topImage = doc.querySelector('figure.wp-block-image img');
    const formImage = doc.querySelector('img[data-image-title="contacto"]');
    this.email.link = email.href;
    this.email.text = email.textContent;
    this.phone.link = phone.href;
    this.phone.text = phone.textContent;
    this.location.text = location;
    this.topImage = topImage.getAttribute('data-orig-file');
    this.formImage = formImage.getAttribute('data-orig-file');
  },
  data() {
    return {
      phone: {
        link: null,
        text: null,
      },
      location: {
        link: null,
        text: null,
      },
      email: {
        link: null,
        text: null,
      },
      topImage: null,
      formImage: null,
    };
  },
};
</script>
